<div class="overlay">
    <mat-spinner 
    mode="indeterminate"
    diameter='50'
    ></mat-spinner>
</div>
